import { getWindow } from './windowUtils'

export const scrollWidget = (element: Element, shift: number) => {
  getWindow()?.scrollTo({
    top: element?.getBoundingClientRect().top + getWindow()?.scrollY - shift,
    behavior: 'smooth',
  })
}
